export default "__VITE_ASSET__CnrZAZYK__"